/* CAMPSTEAD LUX LAYER — motion behaviors */
document.addEventListener("DOMContentLoaded", () => {
  const fine = window.matchMedia("(pointer:fine)").matches &&
               !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* stagger + random hand-placed tilt on option chips */
  document.querySelectorAll(".opt-vals").forEach(v => {
    [...v.querySelectorAll(".opt-btn")].forEach((b, i) => {
      b.style.setProperty("--d", (i * 0.055) + "s");
      b.style.setProperty("--tilt", ((i % 3) - 1) * 1.4 + "deg");
    });
  });

  /* color swatches: map option value -> dab color */
  const SWATCH = {
    "light blue": "#a8c8e4", "red": "#b3382c", "royal": "#2e4a86",
    "white": "#f2ede2", "natural": "#e4d9be", "black": "#2b2822",
    "navy": "#243352", "green": "#4a6741", "forest": "#3d5138",
    "grey": "#9a948c", "gray": "#9a948c", "sand": "#d9c69a",
    "orange": "#d97b2e", "brown": "#5b3a24", "maroon": "#6e2b2b",
    "purple": "#5a4470", "yellow": "#ddb03c", "pink": "#d9a0a8"
  };
  document.querySelectorAll(".opt-block").forEach(blk => {
    const label = (blk.querySelector(".opt-label")?.textContent || "").toLowerCase();
    if (!label.includes("color") && !label.includes("colour")) return;
    blk.querySelectorAll(".opt-btn").forEach(b => {
      const key = b.dataset.v.toLowerCase();
      const c = SWATCH[key] || SWATCH[Object.keys(SWATCH).find(k => key.includes(k)) || ""] || "#c9bfa8";
      b.setAttribute("data-swatch", "");
      b.style.setProperty("--sw", c);
    });
  });

  /* magnetic pull: chips lean toward cursor (the movable feel) */
  if (fine) {
    document.querySelectorAll(".opt-btn, .pp-add, .trust-badge").forEach(el => {
      el.addEventListener("mousemove", e => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - r.left - r.width / 2) / r.width;
        const dy = (e.clientY - r.top - r.height / 2) / r.height;
        el.style.transform = `translate(${dx * 6}px, ${dy * 5 - 3}px) rotate(${dx * 3}deg) scale(1.07)`;
      });
      el.addEventListener("mouseleave", () => { el.style.transform = ""; });
    });

    /* product image: gentle 3D tilt following the cursor */
    const main = document.querySelector(".pp-main");
    if (main) {
      main.addEventListener("mousemove", e => {
        const r = main.getBoundingClientRect();
        const dx = (e.clientX - r.left) / r.width - 0.5;
        const dy = (e.clientY - r.top) / r.height - 0.5;
        main.style.transform = `perspective(900px) rotateY(${dx * 7}deg) rotateX(${-dy * 6}deg) translateY(-2px)`;
      });
      main.addEventListener("mouseleave", () => { main.style.transform = ""; });
    }

    /* side rails drift with scroll (parallax) */
    const rails = document.querySelectorAll(".lux-rail video");
    if (rails.length) {
      let ticking = false;
      window.addEventListener("scroll", () => {
        if (ticking) return; ticking = true;
        requestAnimationFrame(() => {
          const y = window.scrollY * 0.04;
          rails.forEach((v, i) => {
            v.style.transform = `translate(-50%, calc(-50% + ${i ? -y : y}px))`;
          });
          ticking = false;
        });
      }, { passive: true });
    }
  }

  /* measurement modal: play/pause the sketch video with the modal state */
  const sgModal = document.getElementById("sgModal");
  if (sgModal) {
    new MutationObserver(() => {
      const v = sgModal.querySelector("video");
      if (v) { sgModal.classList.contains("open") ? v.play().catch(() => {}) : v.pause(); }
    }).observe(sgModal, { attributes: true, attributeFilter: ["class"] });

    /* selected size on product page highlights its row in the table */
    const syncRow = () => {
      const selSize = document.querySelector(".opt-block .opt-btn.sel")?.dataset.v;
      sgModal.querySelectorAll(".sg-table tbody tr").forEach(tr => {
        tr.classList.toggle("hl", tr.cells[0].textContent.trim() === selSize);
      });
    };
    document.addEventListener("click", e => {
      if (e.target.closest(".opt-btn") || e.target.closest(".sg-link")) setTimeout(syncRow, 30);
    });
    /* clicking a table row selects that size on the page */
    sgModal.querySelectorAll(".sg-table tbody tr").forEach(tr => {
      tr.addEventListener("click", () => {
        const size = tr.cells[0].textContent.trim();
        const btn = [...document.querySelectorAll(".opt-block .opt-btn")].find(b => b.dataset.v === size);
        if (btn) { btn.click(); syncRow(); }
      });
    });
  }

  /* precompute SVG path lengths for the draw-in animation */
  document.querySelectorAll(".sg-draw path, .sg-draw line").forEach(p => {
    try { p.style.setProperty("--len", Math.ceil(p.getTotalLength()) + 1); } catch (e) {}
  });

  /* living ledger: top-rated designs first, the rest reshuffled every visit */
  document.querySelectorAll(".inv-grid").forEach(grid => {
    const cards = [...grid.querySelectorAll(".inv-card")];
    if (cards.length < 3) return;
    const top = cards.filter(c => c.dataset.top);
    const rest = cards.filter(c => !c.dataset.top);
    for (let i = rest.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [rest[i], rest[j]] = [rest[j], rest[i]];
    }
    top.concat(rest).forEach(c => grid.appendChild(c));
  });

  /* ambient float on gallery + info panel */
  document.querySelector(".pp-gallery")?.classList.add("lux-float");
});
